import React from 'react';
import { Box } from '@mui/material';
import { contentAreaStyles } from './ContentArea.styles';

const ContentArea = ({ children }) => {
  return <Box sx={contentAreaStyles.container}>{children}</Box>;
};

export default ContentArea;
